// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-lang-selector .wm-lang-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 14px;
  gap: 10px;
  cursor: pointer;
  height: 40px;
  position: relative;
  background: #ffffff !important;
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  justify-content: center;
}
wm-lang-selector .wm-lang-button .wm-lang-title:not(:empty) ~ .wm-lang-label {
  display: inline;
}
wm-lang-selector .wm-lang-button .wm-lang-title:empty {
  display: none;
}
wm-lang-selector .wm-lang-button .wm-lang-title:empty ~ .wm-lang-label {
  display: none;
}
wm-lang-selector .wm-lang-button .wm-lang-title {
  font-weight: 600;
}
wm-lang-selector .wm-lang-button .wm-lang-label {
  text-transform: lowercase;
  margin-left: -5px;
  display: none;
}
wm-lang-selector .wm-lang-button:has(.wm-lang-title:not(:empty)) {
  justify-content: flex-start;
  gap: 10px;
}
wm-lang-selector .wm-lang-button:has(.wm-lang-title:empty) {
  gap: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/localization/lang-selector/lang-selector.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,8BAAA;EACA,2CAAA;EACA,kBAAA;EACA,uBAAA;AAAJ;AAIM;EACE,eAAA;AAFR;AAOI;EACE,aAAA;AALN;AAOM;EACE,aAAA;AALR;AASI;EACE,gBAAA;AAPN;AAUI;EACE,yBAAA;EACA,iBAAA;EACA,aAAA;AARN;AAaI;EACE,2BAAA;EACA,SAAA;AAXN;AAeI;EACE,MAAA;AAbN","sourcesContent":["wm-lang-selector {\n  .wm-lang-button {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 8px 14px;\n    gap: 10px;\n    cursor: pointer;\n    height: 40px;\n    position: relative;\n    background: #ffffff !important;\n    box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);\n    border-radius: 4px;\n    justify-content: center; // Default: center when only icon\n\n    // When title is not empty, align to left and show label\n    .wm-lang-title:not(:empty) {\n      & ~ .wm-lang-label {\n        display: inline;\n      }\n    }\n\n    // When title is empty, hide title and label, keep icon centered\n    .wm-lang-title:empty {\n      display: none;\n\n      & ~ .wm-lang-label {\n        display: none;\n      }\n    }\n\n    .wm-lang-title {\n      font-weight: 600;\n    }\n\n    .wm-lang-label {\n      text-transform: lowercase;\n      margin-left: -5px;\n      display: none;\n    }\n\n    // When title has content, switch to left alignment\n    // Using :has() for modern browsers, with center as fallback for older browsers\n    &:has(.wm-lang-title:not(:empty)) {\n      justify-content: flex-start;\n      gap: 10px;\n    }\n\n    // When title is empty, ensure gap is 0\n    &:has(.wm-lang-title:empty) {\n      gap: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
